<script setup>
import { computed } from 'vue';

import { HrCircularProgress } from '../primitives';

/**
 * Completion indicator — a 32px circular progress ring showing a task completion percentage.
 *
 * @status recommended
 * @group status-feedback
 * @useWhen Showing the progress of a task or multi-step process as a percentage
 * @related HrUploadProgressIndicator
 * @related HrCountdownRing
 */
defineOptions({ name: 'HrCompletionIndicator' });

const props = defineProps({
  /**
   * Completion percentage (0–100).
   * @example 65
   */
  value: {
    type: Number,
    required: true,
  },
});

// @todo Remove when legacy theme is removed.
const legacyProps = computed(() => ({
  color: 'positive',
  'track-color': 'grey-3',
  thickness: 0.22,
  'font-size': '11px',
}));
</script>

<template>
  <hr-circular-progress
    :value="props.value"
    size="32px"
    color-role="success"
    show-value
    :legacy-props="legacyProps"
  >
    {{ props.value }}%
  </hr-circular-progress>
</template>
